import { getFormattedValue } from '~/lib/getFormattedValue'

import { SIS_DECIMALS, VESIS_DECIMALS } from '~/lib/SISDecimals'

export const CROSSFARMING_DOCUMENTATION_HREF =
	'https://docs.symbiosis.finance/liquidity-providers/cross-chain-farming'
export const CROSSFARMING_DOCUMENTATION_HREF_V2 =
	'https://docs.symbiosis.finance/liquidity-providers/cross-chain-farming-v2'


export function getFormattedSISValue(value?: string): string {
	const formattedValue = getFormattedValue(value, SIS_DECIMALS)

	return `${formattedValue} SIS`
}

export function getFormattedVeSISValue(value?: string): string {
	return getFormattedValue(value, VESIS_DECIMALS)
}
